import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, ApiError } from '../api/client';
import { useAuthStore } from '../store/auth';

export function Welcome() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) return;
    setError(null);
    setSubmitting(true);
    try {
      const r = await authApi.init(password);
      setAuth(r.device_token, r.device_id, r.device_name);
      navigate('/', { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.status === 401) setError('密码错误');
        else if (err.status === 503) setError('服务端未设置密码, 请联系管理员');
        else setError(`错误: ${err.message}`);
      } else {
        setError('网络错误');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-br from-blue-50 to-gray-100 p-4 dark:from-gray-900 dark:to-gray-800">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-5 rounded-xl border border-gray-200 bg-white p-8 shadow-lg dark:border-gray-700 dark:bg-gray-800"
      >
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Todo</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            首次使用请输入应用密码
          </p>
        </div>

        <div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="应用密码"
            autoFocus
            disabled={submitting}
            className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:opacity-50 dark:border-gray-600 dark:bg-gray-700"
          />
        </div>

        {error && (
          <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
        )}

        <button
          type="submit"
          disabled={submitting || !password}
          className="w-full rounded-lg bg-blue-500 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-blue-600 disabled:opacity-50"
        >
          {submitting ? '验证中...' : '进入'}
        </button>
      </form>
    </div>
  );
}